<template>
  <div class="main-content">
    <el-tabs class="el-tabs-common" v-model="current" @tab-click="changeTab">
      <el-tab-pane
        v-for="(item, index) in types"
        :key="index"
        :name="item.type"
        :label="item.name"
      ></el-tab-pane>
    </el-tabs>
    <div
      v-if="['1', '2'].includes(current)"
      class="tab-content"
      :class="{ 'no-tabs': !types.length }"
    >
      <div
        class="vip-tip"
        v-if="vipCourseCount > 0 && $store.state.user_info.is_vip"
      >
        <span>课程中有会员课，会员将于{{ vipEndDate }}过期。</span>
        <router-link
          :to="{ name: 'MemberVip' }"
          class="lnk-vip"
          v-if="vipEndDateCount <= 3"
        >
          去续费
        </router-link>
      </div>
      <div class="courses" v-if="courses.length">
        <template v-if="courses.length > 3">
          <div
            class="nav nav-left"
            @click="navLeft"
            v-if="navLeftIndex > 0"
          ></div>
          <div
            class="nav nav-right"
            @click="navRight"
            v-if="navLeftIndex * 2 < courses.length - 3"
          ></div>
        </template>
        <div style="overflow: hidden">
          <div
            class="item-container clearfix"
            :style="{
              width: courses.length * 300 + 'px',
              marginLeft: -navLeftIndex * 596 + 'px',
            }"
          >
            <div
              class="item"
              :class="{
                selected: item.course_id == currentCourse.course_id,
                class_item: item.class && item.class.name,
                invalid:
                  item.is_vip_course == 1 && !isVipUser && !item.is_buy_order,
              }"
              v-for="(item, index) in courses"
              :key="item.course_id"
              @click="changeCourse(index)"
            >
              <img
                v-if="item.valid_status != 1"
                class="expire"
                src="@/modules/stu/images/expire@2x.png"
              />
              <div class="content">
                <img
                  class="vip-invalid"
                  v-if="
                    item.is_vip_course == 1 && !isVipUser && !item.is_buy_order
                  "
                  src="../../images/invalid@3x.png"
                  style="width: 79px"
                />
                <div class="class_name" v-if="item.class && item.class.name">
                  <span class="eps">{{ item.class.name }}</span>
                </div>
                <div
                  class="title"
                  :title="item.title"
                  :class="{ 'has-vip': item.is_vip_course }"
                >
                  <img
                    class="vip"
                    v-if="item.is_vip_course"
                    src="@/assets/images/course/vip-index@3x.png"
                  />
                  <span class="multi-line-2">{{ item.title }}</span>
                </div>
                <div class="time">
                  <span v-if="item.start_play_date > 0">
                    {{
                      new Date(item.start_play_date * 1000).format("MM月dd日")
                    }}-{{
                      new Date(item.end_play_date * 1000).format("MM月dd日")
                    }}
                  </span>
                  <span
                    v-if="item.course_type != 3 && item.start_play_date > 0"
                    class="line"
                  >
                    |
                  </span>
                  <span v-if="item.course_type != 3">
                    共{{ item.section_num }}课时
                  </span>
                </div>
                <div class="progress-wrap">
                  <div class="progress">
                    <div
                      class="progress-current"
                      :style="{
                        width: (item.progress_rate || 0) + '%',
                      }"
                    ></div>
                  </div>
                  <span>已学习{{ item.progress_rate || 0 }}%</span>
                  <div class="right">
                    <span v-if="item.course_type == 3">
                      <span v-if="item.now_course_num > 0">正在直播</span>
                      <span v-else-if="item.today_course_num > 0">
                        今日有直播
                      </span>
                    </span>
                    <span v-else>
                      <span v-if="item.now_course_num > 0">正在上课</span>
                      <span v-else-if="item.today_course_num > 0">
                        今日有课
                      </span>
                    </span>
                  </div>
                </div>
                <div class="valid">
                  <span v-if="item.valid_type == 1">长期有效</span>
                  <template v-else>
                    <span>{{ item.valid_end_time.replace(/-/g, "/") }}</span>
                    <span v-if="item.valid_status != 1">到期</span>
                    <template v-if="item.end_days >= 0">
                      <span>（</span>
                      <template v-if="item.end_days > 2">
                        <span>还有</span>
                        <span class="days">{{ item.end_days }}</span>
                        <span>天</span>
                      </template>
                      <span
                        class="days"
                        v-else-if="item.end_days == 0"
                        style="margin: 0"
                      >
                        今天
                      </span>
                      <span
                        class="days"
                        v-else-if="item.end_days == 1"
                        style="margin: 0"
                      >
                        明天
                      </span>
                      <span
                        class="days"
                        v-else-if="item.end_days == 2"
                        style="margin: 0"
                      >
                        后天
                      </span>
                      <span>到期）</span>
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="clear: both"></div>
      </div>
      <EmptyNew
        title="当前还没有课程可以学习，快去报名课程吧～"
        v-else
      ></EmptyNew>
      <div class="detail" v-if="detail.course && detail.course.course_id">
        <div class="clear header">
          <span class="f-left teacher" :title="detail.course.teacher_name">
            讲师：{{ detail.course.teacher_name }}
          </span>
          <span class="f-right">
            <a class="comment" @click="beginComment">
              {{ detail.course.is_comment == 1 ? "查看评价" : "评价课程" }}
            </a>
            <span class="line">|</span>
            <router-link
              :to="{
                name: 'CourseShow',
                params: { id: detail.course.course_id },
              }"
            >
              查看课程详情
            </router-link>
            <template v-if="course_qrcode_title">
              <span class="line">|</span>
              <a @click="showQrcodeModal = true">{{ course_qrcode_title }}</a>
            </template>
            <!-- <template v-if="type != 'expire' && currentCourse.course_type != 2">
              <span class="line">|</span>
              <a @click="deleteCourse">
                {{ type == "open" ? "隐藏课程" : "取消隐藏" }}
              </a>
            </template> -->
          </span>
        </div>
        <div class="chapters" v-if="detail.chapter">
          <div
            class="chapter"
            :class="{ expand: chapterExpand[chapter.id] == 1 }"
            v-for="chapter in detail.chapter"
            :key="chapter.id"
          >
            <div class="clear chapter-header" @click="toggleExpand(chapter.id)">
              <div class="flag f-left"></div>
              <div class="title f-left">{{ chapter.title }}</div>
            </div>
            <div class="periods" v-if="chapter.child && chapter.child.length">
              <MemberStudyPeriod
                v-for="period in chapter.child"
                :key="period.id"
                :showDownload="true"
                :period="period"
                :course_id="currentCourse.course_id"
                :course_type="currentCourse.course_type"
                :course="detail.course"
              ></MemberStudyPeriod>
            </div>
          </div>
        </div>
        <div v-else class="period-list-only">
          <template v-if="detail.periods.length">
            <MemberStudyPeriod
              v-for="period in detail.periods"
              :key="period.id"
              :period="period"
              :showDownload="true"
              :course_id="currentCourse.course_id"
              :course_type="currentCourse.course_type"
              :course="detail.course"
            ></MemberStudyPeriod>
          </template>
          <EmptyNew title="该课程暂未设置课时" v-else></EmptyNew>
        </div>
      </div>
      <div
        class="study-exam"
        v-if="this.currentCourse.course_id && exams.length"
      >
        <p class="title">课程考试</p>
        <CourseExam
          :courseId="currentCourse.course_id"
          v-for="exam in exams"
          :key="exam.id"
          :exam="exam"
        ></CourseExam>
      </div>
    </div>
    <template v-else>
      <div v-for="course in courses" :key="course.id">
        <OpenCourseItem
          @onComment="beginComment"
          :course="course"
        ></OpenCourseItem>
      </div>
    </template>
    <el-dialog
      class="comment-dialog"
      title="评价"
      :visible.sync="showCommentDialog"
      width="784px"
    >
      <div v-if="detail.course">
        <div class="name item">课程名称：{{ detail.course.title }}</div>
        <div class="item">
          <label>星级：</label>
          <!--        el-rate disabled为true时，动态值不生效  -->
          <el-rate v-model="commentInfo.grade"></el-rate>
          <div class="mask" v-if="detail.course.is_comment == 1"></div>
          <!--          -->
        </div>
        <div class="item">
          <label>评价内容：</label>
          <br />
          <el-input
            type="textarea"
            :rows="6"
            placeholder="请输入对课程的评价内容，最多500字"
            v-model="commentInfo.content"
            :maxlength="500"
            :readonly="detail.course.is_comment == 1"
          ></el-input>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitComment">确 定</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      class="vip-dialog"
      title="提示"
      :visible.sync="showVipDialog"
      width="500px"
    >
      <div>
        <i class="el-icon-warning" style="color: #e6a23c"></i>
        {{ vipDialogInfo }}
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="
            deleteCourse();
            showVipDialog = false;
          "
        >
          移除课程
        </el-button>
        <el-button type="primary" @click="$router.push({ name: 'MemberVip' })">
          续费会员
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      class="dialog-qrcode"
      :visible.sync="showQrcodeModal"
      :close-on-click-modal="false"
      width="278px"
    >
      <img :src="course_qrcode_img" />
      <a class="close" @click="showQrcodeModal = false"></a>
    </el-dialog>
    <!-- <div class="type-wrap">
      <span
        class="open"
        :class="{ active: type == 'open' }"
        @click="changeType('open')"
      >
        我的课程
      </span>
      <span
        class="expire"
        :class="{ active: type == 'expire' }"
        @click="changeType('expire')"
      >
        已过期
      </span>
      <span
        class="hidden"
        :class="{ active: type == 'hidden' }"
        @click="changeType('hidden')"
      >
        已隐藏
      </span>
    </div> -->
    <MemberCertGet ref="cert"></MemberCertGet>
  </div>
</template>
<script>
import MemberStudyPeriod from "../../components/MemberStudyPeriod.vue";
import MemberCertGet from "../../components/MemberCertGet.vue";
import CourseExam from "../../components/CourseExam.vue";
import OpenCourseItem from "@stu/views/member/components/OpenCourseItem.vue";
import EmptyNew from "@/components/EmptyNew";
import { triggerLoaded } from "@/components/LoadContainer.vue";
import util from "@/utils/plugins";
export default {
  name: "MemberStudy",
  components: {
    MemberStudyPeriod,
    MemberCertGet,
    CourseExam,
    EmptyNew,
    OpenCourseItem,
  },
  data() {
    return {
      user: {},
      current: "2",
      vipCourseCount: 0,
      vipEndDateCount: 0,
      vipEndDate: 0,
      types: [],
      courses: [],
      currentCourse: {},
      currentIndex: 0,
      navLeftIndex: 0,
      detail: {},
      showCommentDialog: false,
      commentInfo: {
        grade: 0,
        content: "",
      },
      chapterExpand: {},
      showVipDialog: false,
      vipDialogInfo: "",
      isVipUser: false,
      course_qrcode_title: "",
      course_qrcode_img: "",
      showQrcodeModal: false,
      type: "open",
      showCertGetModal: true,
      exams: [],
    };
  },
  computed: {
    commonSetting() {
      return this.$store.state.commonSetting;
    },
  },
  watch: {
    commonSetting() {
      this.initTypeName();
    },
    async currentCourse() {
      await this.getCourseDetail();
    },
  },
  async created() {
    let type = this.$route.query.type;
    this.current = (type || 1).toString();
    await this.setVipTip();

    // const id = sessionStorage.getItem('course_id')
    // await this.getData(id)
    // if(type==1){
    //   await this.getData(id)
    // }else{
    //   await this.getData()
    // }

    await this.getData()
    if (
      this.types.length > 0 &&
      this.types.filter(t => t.type == this.current).length == 0
    ) {
      this.current = this.types[0].type.toString();
      await this.getData();
    }
    triggerLoaded(this);

      // const channel = new BroadcastChannel('my_channel');
      // channel.onmessage = (event) => {
      //   console.log(123,this.courses[this.currentIndex])
        
      //   console.log('Received:', event.data);
      // };
  },
  mounted() {
    // document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  destroyed() {
    // document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
  // beforeRouteLeave(to,from,next){
  //   console.log(144,to.name)
  //   if(to.name!='Video'){
  //     sessionStorage.removeItem('course_id')
  //   }
  //   next()
  // },
  methods: {
    // async handleVisibilityChange() {
    //   if (document.visibilityState === 'visible') {
    //     // console.log('窗口已切换回当前页');

    //     if(this.current==1){
    //       await this.getData(this.currentCourse.course_id);
    //       triggerLoaded(this);
    //     }


        
    //   } else {
    //     // console.log('窗口切换到其他页');
    //   }
    // },
    initTypeName() {
      this.types.forEach(t => {
        if (t.type == 1 || t.type == 2 || t.type == 3 || t.type == 11) {
          return;
        }
        t.name = this.commonSetting.course_name[t.type];
      });
    },
    async setVipTip() {
      let user = await this.$http.get("/api/app/userInfo");
      this.user = user;
      let vip = user.vip;
      if (vip && vip.vip_end_at) {
        let end = new Date(vip.vip_end_at * 1000);
        this.vipEndDate = end.format("yyyy年MM月dd日");
        this.vipEndDateCount = parseInt(
          (end.getTime() - new Date().getTime()) / (24 * 60 * 60 * 1000),
        );
        if (this.vipEndDate >= new Date().format("yyyy-MM-dd")) {
          this.isVipUser = true;
        }
      }
    },
    async getData() {
      let data = await this.$http.get(
        "/api/app/myStudy/" + this.current + "?type=" + this.type,
      );
      data.typeNum = data.typeNum.filter(i => i.num !== 0);
      data.typeNum.forEach(t => {
        t.type = t.type.toString();
      });
      this.types = data.typeNum;
      this.initTypeName();
      if (this.$store.state.commonSetting.switch_vip_module !== 1) {
        for (let i = 0; i < this.types.length; i++) {
          if (this.types[i].type == 11) {
            this.types.splice(i, 1);
            break;
          }
        }
      }
      this.vipCourseCount = data.courseList.filter(
        c => c.is_vip_course == 1,
      ).length;
      // 格式化 公开课时间
      if (this.current == 3) {
        data.courseList.forEach(item => {
          item.end_play_date =
            this.$pub.tsToTime(item.start_play_date, false).split(" ")[0] ==
            this.$pub.tsToTime(item.end_play_date, false).split(" ")[0]
              ? this.$pub.tsToTime(item.end_play_date, false).split(" ")[1]
              : this.$pub.tsToTime(item.end_play_date, false);
          item.start_play_date = this.$pub.tsToTime(
            item.start_play_date,
            false,
          );
        });
      }
      this.courses = data.courseList;
      
      if (data.courseList.length > 0) {

        let i = 0;
        const id = this.$route.query.id 
        if (id) {
          for (; i < data.courseList.length; i++) {
            if (data.courseList[i].course_id == id) {
              this.currentCourse = data.courseList[i];
              this.navLeftIndex = parseInt(i / 2);
              this.currentIndex = i;
              break;
            }
          }
        }
        if (!id || i == data.courseList.length) {
          this.currentCourse = data.courseList[0];
          this.navLeftIndex = 0;
          this.currentIndex = 0;
        }
      }
      // else if (this.types.length > 0) {
      //   this.current = this.types[0].type;
      //   await this.getData();
      // }
      else {
        this.currentCourse = {};
        this.navLeftIndex = 0;
        this.currentIndex = 0;
      }
    },
    async changeCourse(index) {
      this.currentCourse = this.courses[index];

      sessionStorage.setItem('course_id',this.currentCourse.course_id)

      this.currentIndex = index;
    },
    async changeTab(item) {
      console.log(item.name);

      this.current = item.name;
      this.courses=[]
      await this.getData();
      
    },
    navLeft() {
      if (this.navLeftIndex == 0) {
        return;
      }
      this.navLeftIndex--;
    },
    navRight() {
      if (this.navLeftIndex >= this.courses.length - 1) {
        return;
      }
      this.navLeftIndex++;
    },
    formatPerid(perid) {
      let teacherNames = [];
      perid.teachers.forEach(t => {
        teacherNames.push(t.teacher_name);
      });
      perid.teacher_name = teacherNames.join(",");
      let files = [];
      if (perid.datum && perid.datum.length > 0) {
        perid.datum.forEach(item => {
          files.push({
            file_name: item.file_name,
            datum_id: item.datum_id,
            fid: item.fid.split(";"),
            file_ext: util.getFileType(item.file_name),
          });
        });
      }
      perid.files = files;
    },
    async getCourseDetail() {
      if (!this.currentCourse.course_id) {
        this.detail = {};
        return;
      }
      if (
        this.currentCourse.is_vip_course == 1 &&
        !this.isVipUser &&
        this.currentCourse.is_buy_order == 0
      ) {
        this.detail = {};
        this.vipDialogInfo = "您的会员已失效";
        this.showVipDialog = true;
        return;
      }
      await this.getExam();
      this.detail = await this.$http.get(
        "/api/app/myStudy/course/" + this.currentCourse.course_id,
      );
      let chapterExpand = {};
      if (this.detail.chapter) {
        this.detail.chapter.forEach(c => {
          chapterExpand[c.id] = 0;
          if (!c.child) {
            return;
          }
          c.child.forEach(child => {
            this.formatPerid(child);
          });
        });
      } else if (this.detail.periods) {
        this.detail.periods = this.detail.periods.filter(p => p.parent_id != 0);

       const isLive =(start,end)=>{//  1未开播  2直播中  3直播结束
          if(start==0){return 1}//未开播
          if(start!=0 && end==''){return 2}//直播中
          if(start!=0 && end!=''){return 3}//直播结束
        }
        

        this.detail.periods.forEach(p => {
          p.play_type = isLive(p.start_op_time,p.end_op_time)
          if(p.child){
            p.child.forEach(i=>{
              i.play_type = isLive(i.start_op_time,i.end_op_time)
            })
          }
          this.formatPerid(p);
        });
      }
      this.chapterExpand = chapterExpand;
      let courseQrcode = await this.$http.get(
        "/api/app/myStudy/courseQrcode/" + this.currentCourse.course_id,
      );
      this.course_qrcode_title = courseQrcode.code_title;
      this.course_qrcode_img = courseQrcode.code_img;
      if (this.detail.cert.length > 0) {
        this.$refs.cert.show(this.detail.cert);
      }
    },
    async deleteCourse() {
      if (this.type == "open") {
        await this.$confirm(
          "隐藏后，可在“我的课程-隐藏列表”中查看和恢复",
          "提示",
          { type: "warning" },
        );
      }
      await this.$http.delete(
        "/api/app/myStudy/course/" + this.currentCourse.course_id,
      );
      if (this.type == "hidden") {
        await this.$success("取消隐藏成功");
      }
      if (this.type == "hidden" || this.type == "expire") {
        this.current = "1";
      }
      let data;
      if (this.type == "open") {
        data = await this.$http.get(
          "/api/app/myStudy/" + this.current + "?type=" + this.type,
        );
        if (data.typeNum && data.typeNum.length > 0) {
          data = await this.$http.get(
            "/api/app/myStudy/" + data.typeNum[0].type + "?type=" + this.type,
          );
          this.current = data.typeNum[0].type + "";
        }
      }
      await this.getData();
    },
    async beginComment() {
      this.commentInfo.grade = 5;
      this.commentInfo.content = "";
      if (this.detail.course.is_comment == 1) {
        let data = await this.$http.get(
          "/api/app/myStudy/comment/" + this.detail.course.course_id,
        );
        this.commentInfo.grade = data.grade;
        this.commentInfo.content = data.content;
      }
      this.showCommentDialog = true;
    },
    async submitComment() {
      if (this.detail.course.is_comment == 1) {
        this.showCommentDialog = false;
        return;
      }
      if (this.commentInfo.grade == 0) {
        await this.$info("请选择星级");
        return;
      }
      if (this.commentInfo.content == "") {
        await this.$info("请输入评价内容");
        return;
      }
      await this.$http.post("/api/app/myStudy/comment", {
        grade: this.commentInfo.grade,
        content: this.commentInfo.content,
        course_id: this.detail.course.course_id,
        type: 1,
      });
      this.showCommentDialog = false;
      if (this.current == 3) {
        this.getData();
      } else {
        this.detail.course.is_comment = 1;
      }
      await this.$success("评价成功");
    },
    toggleExpand(id) {
      if (this.chapterExpand[id] == 0) {
        this.chapterExpand[id] = 1;
      } else {
        this.chapterExpand[id] = 0;
      }
    },
    async changeType(type) {
      this.type = type;
      if (this.type == "hidden" || this.type == "expire") {
        this.current = "1";
      }
      let data;
      if (this.type == "open") {
        data = await this.$http.get(
          "/api/app/myStudy/" + this.current + "?type=" + this.type,
        );
        if (data.typeNum && data.typeNum.length > 0) {
          data = await this.$http.get(
            "/api/app/myStudy/" + data.typeNum[0].type + "?type=" + this.type,
          );
          this.current = data.typeNum[0].type + "";
        }
      }
      await this.getData();
    },
    async getExam() {
      this.exams = await this.$http.get(
        `/api/app/course/getTest/${this.currentCourse.course_id}`,
      );
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../css/member-study.scss";
/deep/ {
  .el-tabs__header {
    margin-bottom: 0px;
  }
}
</style>
